import { Reducer, handleActions } from "redux-actions";
import { LoginDevice } from "../../javascripts/public";
import {
    ACTION_LOGINENTRYINS_SUCCESS,
    ACTION_LOGINSILIZHUENTRYINS_SUCCESS,
    ACTION_LOGINENTRYMERCHANT_SUCCESS,
    ACTION_LOGINSILIZHUENTRYMERCHANT_SUCCESS,
    ACTION_LOGOUT_SUCCESS,
    ACTION_GETMENUANDORG_SUCCESS,
    ACTION_GETSILIZHUMENUANDORG_SUCCESS,
    ACTION_UPDATEORGINFO_SUCCESS,
    ACTION_SENDCAPTCHA_SUCCESS,
    ACTION_ADDADMIN_SUCCESS,
    ACTION_DELETEADMIN_SUCCESS,
    ACTION_GETADMININFO_SUCCESS,
    ACTION_ADDSTAFF_SUCCESS,
    ACTION_DELETESTAFF_SUCCESS,
    ACTION_REGISTER_SUCCESS,
    ACTION_RESETPASSWORD_SUCCESS,
    ACTION_SUREORG_SUCCESS,
    ACTION_LOGINENTRYINS_FAIL,
    ACTION_REGISTER_FAIL,
    ACTION_OPERATEUSER_FAIL,
    ACTION_CHANGEPASSWORD_SUCCESS
} from '../actions/user'

export interface userState {
    accessToken: string
    orgInfo: any,
    insInfo: any,
    orgList: any[]
    orgId: string
    orgGroupId: string,
    loginStatus: boolean
    menuData: any[],
    routeKey: string
    adminList: any[],
    superAdmin: any
    adminGroupId: any
    staffGroupId: any,
    isRegister: boolean,
    isResetPassword: boolean,
    isSure: boolean,
    loginInsFailData: string,
    registerFailData: string,
    isSuccess: boolean,
    failData: string
    accountGroups: any[],
    role: string,
    loginDevice: LoginDevice | string
}

let accessToken = localStorage.getItem('accessToken') || '';
let loginStatus = localStorage.getItem('loginStatus') ;
let orgGroupId = localStorage.getItem('orgGroupId') || '';
let orgId = localStorage.getItem('orgId') || '';
let routeKey = localStorage.getItem('routeKey') || '';
let role = localStorage.getItem('role') || '';
const loginDevice = localStorage.getItem("loginDevice") || LoginDevice.SCANNER

const defaultState: userState = {
    accessToken: accessToken,
    orgInfo: {},
    insInfo: {},
    orgList: [],
    orgId: orgId,
    orgGroupId: orgGroupId,
    loginStatus: loginStatus == 'true',
    menuData: [],
    routeKey: routeKey,
    adminList: [],
    superAdmin: {},
    adminGroupId: 0,
    staffGroupId: 0,
    isRegister: false,
    isResetPassword: false,
    isSure: true,
    loginInsFailData: '',
    registerFailData: '',
    isSuccess: false,
    failData: '',
    accountGroups: [],
    role: role,
    loginDevice: loginDevice
}

function handleActionLoginEntryInsSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`);
    let key = 'institution';
    localStorage.setItem('routeKey', key);
    localStorage.setItem('loginStatus', 'true');
    return {
        ...state,
        accessToken: action.payload.accessToken,
        orgList: action.payload.orgList,
        loginStatus: true,
        routeKey: key,
        loginInsFailData: '',
        menuData: [],
        accountGroups: action.payload.accountGroups,
        loginDevice: LoginDevice.SCANNER,
    }
}

function handleActionLoginSilizhuEntryInsSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`);
    let key = 'institution';
    localStorage.setItem('routeKey', key);
    localStorage.setItem('loginStatus', 'true');
    return {
        ...state,
        accessToken: action.payload.accessToken,
        orgList: action.payload.orgList,
        loginStatus: true,
        routeKey: key,
        loginInsFailData: '',
        menuData: [],
        loginDevice: LoginDevice.SILIZHU,
    }
}


function handleActionLoginEntryInsFail(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`);
    return {
        ...state,
        loginInsFailData: action.payload.data
    }
}


function handleActionLoginEntryMerchantSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`);
    let key = 'merchant';
    localStorage.setItem('routeKey', key);
    localStorage.setItem('loginStatus', 'true');
    return {
        ...state,
        accessToken: action.payload.accessToken,
        orgList: action.payload.orgList,
        loginStatus: true,
        routeKey: key,
        loginInsFailData: '',
        menuData: [],
        accountGroups: action.payload.accountGroups,
    }
}

function handleActionLoginSilizhuEntryMerchantSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`);
    let key = 'merchant';
    localStorage.setItem('routeKey', key);
    localStorage.setItem('loginStatus', 'true');
    return {
        ...state,
        accessToken: action.payload.accessToken,
        orgList: action.payload.orgList,
        loginStatus: true,
        routeKey: key,
        loginInsFailData: '',
        menuData: [],
        loginDevice: LoginDevice.SILIZHU,
    }
}

function handleActionSureOrgSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`);
    return {
        ...state,
        orgInfo: action.payload.org,
        orgId: action.payload.orgId,
        isSure: true,
        role: action.payload.role,
    }
}

function handleActionLogoutSuccess(state: userState, action): userState {
    console.log(`ACTION: ${action.type}`);
    localStorage.setItem('loginStatus', 'false');
    return {
        ...state,
        loginStatus: false,
        isSure: false
    }
}

function handleActionGetMenuAndOrgSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        menuData: action.payload.menuData,
        orgInfo: action.payload.orgInfo,
        orgGroupId: action.payload.orgGroupId,
        insInfo: action.payload.insInfo,
    }
} 

function handleActionGetSilizhuMenuAndOrgSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        menuData: action.payload.menuData,
        orgInfo: action.payload.orgInfo,
    }
} 

function handleActionGetAdminInfoSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        adminList: action.payload.adminList,
        superAdmin: action.payload.superAdmin,
        adminGroupId: action.payload.adminGroupId,
        staffGroupId: action.payload.staffGroupId,
    }
} 

function handleActionUpdateOrgInfoSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isSuccess: true,
        failData: '',
    }
} 

function handleActionSendCaptchaSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    }
} 

function handleActionAddAdminSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isSuccess: true,
        failData: '',
    }
}

function handleActionDeleteAdminSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    }
}

function handleActionAddStaffSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isSuccess: true,
        failData: '',
    }
}

function handleActionDeleteStaffSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    }
}

function handleActionResetPasswordSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isResetPassword: true
    }
}

function handleActionRegisterSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isRegister: true,
        registerFailData: ''
    }
}

function handleActionRegisterFail(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        registerFailData: action.payload.data
    }
}

function handleActionOperateUserFail(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isSuccess: false,
        failData: action.payload.data
    }
}

function handleActionChangePasswordSuccess(state: userState, action: any): userState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    };
}

export const userReducer: Reducer<userState, any> = handleActions(
    {
        [ACTION_LOGINENTRYINS_SUCCESS]: handleActionLoginEntryInsSuccess,
        [ACTION_LOGINSILIZHUENTRYINS_SUCCESS]: handleActionLoginSilizhuEntryInsSuccess,
        [ACTION_LOGINENTRYINS_FAIL]: handleActionLoginEntryInsFail,
        [ACTION_LOGINENTRYMERCHANT_SUCCESS]: handleActionLoginEntryMerchantSuccess,
        [ACTION_LOGINSILIZHUENTRYMERCHANT_SUCCESS]: handleActionLoginSilizhuEntryMerchantSuccess,
        [ACTION_LOGOUT_SUCCESS]: handleActionLogoutSuccess,
        [ACTION_GETMENUANDORG_SUCCESS]: handleActionGetMenuAndOrgSuccess,
        [ACTION_GETSILIZHUMENUANDORG_SUCCESS]: handleActionGetSilizhuMenuAndOrgSuccess,
        [ACTION_GETADMININFO_SUCCESS]: handleActionGetAdminInfoSuccess,
        [ACTION_UPDATEORGINFO_SUCCESS]: handleActionUpdateOrgInfoSuccess,
        [ACTION_SENDCAPTCHA_SUCCESS]: handleActionSendCaptchaSuccess,
        [ACTION_ADDADMIN_SUCCESS]: handleActionAddAdminSuccess,
        [ACTION_DELETEADMIN_SUCCESS]: handleActionDeleteAdminSuccess,
        [ACTION_ADDSTAFF_SUCCESS]: handleActionAddStaffSuccess,
        [ACTION_DELETESTAFF_SUCCESS]: handleActionDeleteStaffSuccess,
        [ACTION_RESETPASSWORD_SUCCESS]: handleActionResetPasswordSuccess,
        [ACTION_REGISTER_SUCCESS]: handleActionRegisterSuccess,
        [ACTION_REGISTER_FAIL]: handleActionRegisterFail,
        [ACTION_SUREORG_SUCCESS]: handleActionSureOrgSuccess,
        [ACTION_OPERATEUSER_FAIL]: handleActionOperateUserFail,
        [ACTION_CHANGEPASSWORD_SUCCESS]: handleActionChangePasswordSuccess,
    },
    defaultState
)